export interface Bbox { minLat: number; minLon: number; maxLat: number; maxLon: number }
export interface Tile { z: number; x: number; y: number }

export function lonToTileX(lon: number, z: number): number {
  return Math.floor(((lon + 180) / 360) * 2 ** z);
}

export function latToTileY(lat: number, z: number): number {
  const rad = (lat * Math.PI) / 180;
  return Math.floor(
    ((1 - Math.log(Math.tan(rad) + 1 / Math.cos(rad)) / Math.PI) / 2) * 2 ** z,
  );
}

/** Every tile covering `bbox` for each zoom level in [minZoom, maxZoom]. */
export function tileRange(bbox: Bbox, minZoom: number, maxZoom: number): Tile[] {
  const tiles: Tile[] = [];
  for (let z = minZoom; z <= maxZoom; z += 1) {
    const x0 = lonToTileX(bbox.minLon, z);
    const x1 = lonToTileX(bbox.maxLon, z);
    // Latitude tile indices increase southward, so maxLat yields the smaller y.
    const y0 = latToTileY(bbox.maxLat, z);
    const y1 = latToTileY(bbox.minLat, z);
    for (let x = Math.min(x0, x1); x <= Math.max(x0, x1); x += 1) {
      for (let y = Math.min(y0, y1); y <= Math.max(y0, y1); y += 1) {
        tiles.push({ z, x, y });
      }
    }
  }
  return tiles;
}
